"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConfigurationProvider {
    constructor(options) {
        if (!options.url) {
            throw new Error('The parameter "url" is required.');
        }
        if (options.url.endsWith('/')) {
            options.url = options.url.substr(0, options.url.length - 1);
        }
        this.url = options.url;
        this.jwtToken = options.jwtToken;
        this.refreshTokenId = options.refreshTokenId;
        this.logger = options.logger || { log: () => { }, error: console.error };
        this.requestIdProvider = options.requestIdProvider || (() => this.uuid());
        this.requestFromProvider = options.requestFromProvider || (() => 'unknown');
        this.requestFromVersionProvider = options.requestFromVersionProvider || (() => 'unknown');
        this.requestTagsProvider = options.requestTagsProvider || (() => ({}));
    }
    setRefreshedToken(token) {
        this.jwtToken = token;
    }
    uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
exports.ConfigurationProvider = ConfigurationProvider;
class GatewayConfiguration extends ConfigurationProvider {
    constructor(url, jwtToken, refreshTokenId, logger, requestIdProvider, requestFromProvider, requestTagsProvider) {
        super({ url, jwtToken, refreshTokenId, logger, requestIdProvider, requestFromProvider, requestTagsProvider });
    }
    getConfiguration() {
        return this;
    }
}
exports.GatewayConfiguration = GatewayConfiguration;
class GatewayConfigurationV2 extends ConfigurationProvider {
    constructor(options) {
        super(options);
    }
    getConfiguration() {
        return this;
    }
}
exports.GatewayConfigurationV2 = GatewayConfigurationV2;
//# sourceMappingURL=gateway.configuration.js.map